import React, { FC, useState } from 'react'
import { PaymentFailure } from './types'
import { useDialogStyles } from './styles'
import { PromptButton } from './dialog-parts'
import { useIsMounted } from './use-is-mounted'

export const HostedInvoiceLink: FC<{ url: string; label: string }> = ({ url, label }) => (
  <a
    className={useDialogStyles().link}
    href={url}
    rel='noopener noreferrer'
    target='_blank'
  >
    {label}
  </a>
)

interface FailureNoticeProps {
  failure: PaymentFailure
  // Fetches the bill again (its new amount) and clears the failure once it is in.
  onRefresh: () => Promise<unknown>
}

// Why the last Pay click did not go through, and what the customer can do about it.
export const FailureNotice: FC<FailureNoticeProps> = ({ failure, onRefresh }) => {
  const classes = useDialogStyles()
  const [refreshing, setRefreshing] = useState(false)
  const isMounted = useIsMounted()
  const refresh = async () => {
    setRefreshing(true)
    await onRefresh()
    // A successful refresh clears the failure, and this notice with it.
    if (isMounted()) setRefreshing(false)
  }
  return (
    <div role='alert'>
      <p className={classes.error}>{failure.message}</p>
      {failure.hostedInvoiceUrl && (
        <HostedInvoiceLink
          label="Pay on Stripe's secure page instead"
          url={failure.hostedInvoiceUrl}
        />
      )}
      {failure.amountChanged && (
        <PromptButton
          disabled={refreshing}
          onClick={refresh}
          variant='textPrimary'
        >
          Refresh the amount
        </PromptButton>
      )}
    </div>
  )
}
